export enum EventAuditEnum {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  RESTORED = 'restored',
}

export enum TimezoneCode {
  KALININGRAD = 'Europe/Kaliningrad', // UTC+2
  MOSCOW = 'Europe/Moscow', // UTC+3
  SAMARA = 'Europe/Samara', // UTC+4
  YEKATERINBURG = 'Asia/Yekaterinburg', // UTC+5
  OMSK = 'Asia/Omsk', // UTC+6
  KRASNOYARSK = 'Asia/Krasnoyarsk', // UTC+7
  IRKUTSK = 'Asia/Irkutsk', // UTC+8
  YAKUTSK = 'Asia/Yakutsk', // UTC+9
  VLADIVOSTOK = 'Asia/Vladivostok', // UTC+10
  MAGADAN = 'Asia/Magadan', // UTC+11
  KAMCHATKA = 'Asia/Kamchatka', // UTC+12
}

export enum DriverStatus {
  CREATED = 'CREATED',
  CHECKS_STARTING = 'CHECKS_STARTING',
  CHECKING = 'CHECKING',
  CHECKS_FINISHED = 'CHECKS_FINISHED',
  CHECKS_EXPIRED = 'CHECKS_EXPIRED',
  ADDITIONAL_APPROVAL_REQUESTED = 'ADDITIONAL_APPROVAL_REQUESTED',
  CHECKS_CANCELLATION_REQUESTED = 'CHECKS_CANCELLATION_REQUESTED',
  CHECKS_RETRY_REQUESTED = 'CHECKS_RETRY_REQUESTED',
  REJECTED = 'REJECTED',
  REJECT_IN_PROGRESS = 'REJECT_IN_PROGRESS',
  APPROVE_IN_PROGRESS = 'APPROVE_IN_PROGRESS',
  APPROVED = 'APPROVED',
  CHECKS_CANCELLED = 'CHECKS_CANCELLED',
  SENT_TO_COMANDIR = 'SENT_TO_COMANDIR',
  FIRED = 'FIRED',
  WORKS = 'WORKS',
}

export enum MassMailingStatus {
  WAITING = 'waiting',
  PROCESSING = 'processing',
  FINISHED = 'finished',
}
